module.exports = "<div ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-credit-components/src/bml-display/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-credit-components/src/bml-display/template.html
// module chunks = 1